import { LookupField } from './../../core/api.gen';

import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { isNullOrUndefined } from 'src/app/core';
import { LookupApi, LookupFieldGridInfo, SortParameters } from 'src/app/core/api.gen';
import { CommonService } from 'src/app/core/common.service';
import { DialogService } from 'src/app/core/dialog.service';
import { LoaderService } from 'src/app/core/loader.service';

@Component({
  selector: 'eos-lookup-type-amendment',
  templateUrl: './lookup-type-amendment.component.html',
  styleUrls: ['./lookup-type-amendment.component.scss']
})
export class LookupTypeAmendmentComponent implements OnInit {

  lookupTypes = new UntypedFormGroup({
    lookupType: new UntypedFormControl(null, [Validators.required]),
  });
  lktypes = [];

  dataWithFilter: LookupFieldGridInfo = new LookupFieldGridInfo();
  currentPage = 1;
  page: number;
  changeCount: number[] = [10, 15, 25];
  totalPages: number;
  lookupTypeId: number = 0;
  isEditable: boolean = true;
  dropdownModule: string;

  constructor(
    private lookupApi: LookupApi,
    private dialogService: DialogService,
    private loader: LoaderService,
    private route: ActivatedRoute) {
    this.dataWithFilter.sortParameters = new SortParameters();
    this.dataWithFilter.lookupFields = [];
    route.paramMap.subscribe(params => {
      let isModuleChanged = false;
      if(!isNullOrUndefined(this.dropdownModule) && this.dropdownModule != params.get('module')){
        isModuleChanged = true;
        this.lookupTypes.get('lookupType').reset();
        this.lktypes = [];
        this.dataWithFilter.lookupFields = [];
        this.lookupTypeId = 0;
      }
      this.dropdownModule = params.get('module');
      if(isModuleChanged)
      this.loadFilterData();
    });
  }

  get canCreate(): boolean {
     
    return this.isEditable;
  }

  ngOnInit() {
    this.loadFilterData();
    this.initalizePagination();
  }

  initalizePagination() {
    this.dataWithFilter.sortParameters.page = 1;
    this.dataWithFilter.sortParameters.itemsPerPage = 10;
    this.dataWithFilter.sortParameters.totalRecords = 0;
  }

  loadFilterData() {
    this.loader.show();
    this.lookupApi.getAllActiveLookupType()
      .subscribe(resp => {
        this.loader.clear();
        this.lktypes = resp.filter(x => x.module ==  this.dropdownModule);
      });
  }


  editlookup(lookup: LookupField) {
    this.dialogService.showLookupAmendEdit(lookup, this.dropdownModule).result.then(resp => {
      this.getLookupGrid();
    }, dismiss => {
      this.getLookupGrid();
    });
  }

  createLookup() {

    this.dialogService.showLookupAmendCreate(this.lookupTypeId, this.dropdownModule).result.then(resp => {
      this.getLookupGrid();
    }, dismiss => {
      this.getLookupGrid();
    });
  }

  getLookupData(e) {
    this.initalizePagination();
    this.lookupTypeId = e.id;
    this.isEditable = e.isEditable
    this.getLookupGrid();

  }
  getLookupGrid() {
    this.lookupApi.getLookupFieldDataByTypeId(this.lookupTypeId, this.dataWithFilter.sortParameters).subscribe(log => {
      this.dataWithFilter = log;
    });
  }

  pageChanged(event: any): void {
    this.dataWithFilter.sortParameters.itemsPerPage = event.itemsPerPage;
    this.dataWithFilter.sortParameters.page = event.page;
    this.getLookupGrid();
  }

  onSelectChanges() {
    this.getLookupGrid();
  }



}
